import { IDnDData } from './';
import { DnDTools } from './DnDTools';

export class DnDDataWriter
    implements IDnDData {

    public typeName?: string;
    public value?: any;

    public write(dataTransfer: DataTransfer): void {
        if (!this.typeName || this.typeName.length === 0) { throw new Error('typeName is not set'); }
        if (!this.value) { throw new Error('value is not set'); }

        let mimeType = DnDTools.getMimeType(this.typeName);
        const json = JSON.stringify(this.value);
        try {
            dataTransfer.setData(mimeType, json);
            if (dataTransfer.types.findIndex(x => x === mimeType) < 0) {
                mimeType = DnDTools.getMimeTypeForEdge(this.typeName);
                dataTransfer.setData(mimeType, json);
            }
        } catch (ex) {
            if (typeof(ex.number) === 'number' && ex.number === -2147418113) {
                dataTransfer.setData(DnDTools.IE11MimeType, json);
            } else {
                throw ex;
            }
        }
    }
}
